import { useCallback, useMemo } from 'react';
import { ApolloError, FetchResult } from '@apollo/client';
import {
  PutAutoAcceptSettingInput,
  PutAutoPilotSettingsMutation,
  usePutAutoPilotSettingsMutation
} from 'graphql/types';

export const usePutAutoPilotSettings = (): {
  putAutoPilotSettings: (
    input: PutAutoAcceptSettingInput
  ) => Promise<FetchResult<PutAutoPilotSettingsMutation>>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    putAutoPilotSettingsMutation,
    { loading, error }
  ] = usePutAutoPilotSettingsMutation();

  const putAutoPilotSettings = useCallback(
    async (input: PutAutoAcceptSettingInput) =>
      await putAutoPilotSettingsMutation({
        variables: {
          input
        },
        awaitRefetchQueries: true,
        refetchQueries: ['getAutoPilotSettings']
      }),
    [putAutoPilotSettingsMutation]
  );

  return useMemo(
    () => ({
      putAutoPilotSettings,
      loading,
      error
    }),
    [putAutoPilotSettings, loading, error]
  );
};
